import Form from '../partials/form'

$(document).on('ready', () => {
  if ($('#admin-dynamic_forms-edit').length !== 0) {
    new Form().setup()
  }
})
